import { parseISO, parse } from 'date-fns';

const parseDate = (pageName) => {
    // First, try to parse as ISO date (in case the format changes in the future)
    let date = parseISO(pageName);
    
    if (isNaN(date.getTime())) {
      // If it's not an ISO date, parse it using our custom format
      date = parse(pageName, 'MMM do, yyyy', new Date());
    }
    
    return date;
  };

const createSyntheticBlock = (id, title, children) => ({
    id,
    'page-name': title,
    children,
    synthetic: true
});

const defaultViewBuilder = (blocks) => {
    const pinnedBlocks = blocks.filter(block => block.properties?.pinned === 'true');
    const journalBlocks = blocks.filter(block => block.properties?.type === 'journal' ).sort((a, b) => {
      const dateA = parseDate(a['page-name']);
      const dateB = parseDate(b['page-name']);
      return dateB.getTime() - dateA.getTime(); // Sort from newest to oldest
    });
    // const otherBlocks = blocks.filter(block =>
    //     !pinnedBlocks.includes(block) && !journalBlocks.includes(block)
    // );

    return [
        createSyntheticBlock('pinned-section', 'Pinned', pinnedBlocks),
        createSyntheticBlock('journal-section', 'Journal', journalBlocks),
    ].filter(block => block.children.length > 0);
};

// You can add more view builders here in the future
// const anotherViewBuilder = (blocks) => { ... };

export const buildView = (viewName, blocks) => {
    switch (viewName) {
        case 'default':
            return defaultViewBuilder(blocks);
        // Add cases for other views here
        // case 'another-view':
        //   return anotherViewBuilder(blocks);
        default:
            console.warn(`Unknown view name: ${viewName}. Falling back to default view.`);
            return defaultViewBuilder(blocks);
    }
};